module.exports = __webpack_public_path__ + "img/events-1.b386d07c.png";